import { Card, CardContent } from "@/components/ui/card";
import { ComponentProps } from "@/types/component-props.type";

const TestimonialsComponent = ({ sectionRef }: ComponentProps) => {
  return (
    <section ref={sectionRef} className="py-12 px-4 custom-bg-color-02">
      <div className="max-w-6xl mx-auto">
        <h3 className="text-3xl font-bold text-center mb-4 custom-color-01">
          Experiências autênticas de quem já aplicou princípios bíblicos
        </h3>
        <p className="text-center mb-12 text-lg custom-color-01">
          em situações reais
        </p>

        <div className="grid md:grid-cols-2 gap-8" >
          <Card className="shadow-md hover:shadow-lg transition-shadow custom-bg-color-01 custom-border-color-05">
            <CardContent className="p-6">
              <p className="mb-4 italic custom-color-03">
                "O Congresso de Aconselhamento foi bênção na minha vida,pois me
                despertou para a importânca de examinar minhas emoções à luz da
                Bíblia com profundidade."
              </p>
              <p className="font-semibold custom-color-04">— Liliam Marques</p>
              <p className="text-sm custom-color-02">
                Igreja Presbiteriana da Aliança - Santa Luzia - MG
              </p>
            </CardContent>
          </Card>

          <Card className="shadow-md hover:shadow-lg transition-shadow custom-bg-color-01 custom-border-color-05">
            <CardContent className="p-6">
              <p className="mb-4 italic custom-color-03">
                "O Congresso de Aconselhamento foi maravilhoso. Ficamos felizes
                com a oportunidade oferecida aos missionários, e também o pós
                conferência foi um diferencial."
              </p>
              <p className="font-semibold custom-color-04">
                — Pr. Marcelo Ramos
              </p>
              <p className="text-sm custom-color-02">
                Vice-diretor da WEC Brasil, Recife - PE
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsComponent;
